import { useAtom, useSetAtom } from "jotai";
import { useMediaQuery } from "@/ui/hooks/useMediaQuery";
import {
    mobileRightDrawerOpenAtom,
    rightDrawerOpenAtom,
} from "@/features/Navigation/state";
import { selectedMetricForDrawerAtom } from "../../state";
import { Metric } from "@/entities/Finance/Finance.model";

export function useMetricClickHandler() {
    const isMobile = useMediaQuery("(max-width: 640px)");
    const [, setMobileRightDrawerOpen] = useAtom(mobileRightDrawerOpenAtom);
    const [, setRightDrawerOpen] = useAtom(rightDrawerOpenAtom);
    const setSelectedMetricForDrawer = useSetAtom(selectedMetricForDrawerAtom);

    return (metric: Metric | undefined, title: string) => {
        setSelectedMetricForDrawer({
            metric,
            title,
        });

        if (isMobile) {
            setMobileRightDrawerOpen(true);
        } else {
            setRightDrawerOpen(true);
        }
    };
}
